<template>
    <Dialog
        :visible="productDialog"
        :style="{ width: '100vw' }"
        :maximizable="false"
        position="top"
        class="p-fluid p-m-0 p-dialog-maximized"
        :closable="false"
    >
        <template #header>
            <h4 class="p-dialog-titlebar p-dialog-titlebar-icon">
                {{ dialogTitle }}
            </h4>
        </template>
        <p class="warning-content p-mb-3">Add a Product.</p>

        <div class="p-grid">
            <div class="p-col">
                <div class="p-field">
                    <label for="productName">Product Name*</label>
                    <InputText
                        id="productName"
                        v-model="product.product_name"
                        placeholder="e.g Panadol"
                    />
                    <small
                        class="p-error"
                        v-if="validationErrors.product_name"
                        >{{ validationErrors.product_name }}</small
                    >
                </div>
                <div class="p-field">
                    <label for="genericName">Generic Name*</label>
                    <InputText
                        id="genericName"
                        v-model="product.generic_name"
                        placeholder="e.g Paracetamol"
                    />
                    <small
                        class="p-error"
                        v-if="validationErrors.generic_name"
                        >{{ validationErrors.generic_name }}</small
                    >
                </div>
                <div class="p-field">
                    <label for="commonName">Common Name</label>
                    <InputText
                        id="commonName"
                        v-model="product.common_name"
                        placeholder=""
                    />
                </div>

                <div class="p-field">
                    <label for="reference">Reference*  <span class="small-span-ref">(Last Reference: {{ lastReference  }})</span></label>
                    <InputText id="reference" v-model="product.reference" />
                    <small class="p-error" v-if="validationErrors.reference">{{
                        validationErrors.reference
                    }}</small>
                </div>
                <div class="p-field">
                    <label for="minStock">Minimum Stock</label>
                    <InputText id="minStock" v-model="product.min_stock" />
                    <small class="p-error" v-if="validationErrors.min_stock">{{
                        validationErrors.min_stock
                    }}</small>
                </div>
                <div class="p-field">
                    <label for="minStock">Product Location</label>
                    <InputText
                        id="minStock"
                        v-model="product.product_location"
                    />
                </div>
                <div class="p-field">
                    <label for="barcode">Barcode</label>
                    <InputText id="barcode" v-model="product.barcode" />
                </div>

                <div class="p-field">
                    <label for="unitName">Unit Name</label>
                    <Dropdown
                        id="unitName"
                        v-model="product.unit_id"
                        :options="unit"
                        placeholder="Unit Name"
                        :filter="true"
                        optionLabel="option_name"
                        optionValue="id"
                    />
                </div>
                <div class="p-field">
                    <label for="unitValue">Unit Value</label>
                    <InputText id="unitValue" v-model="product.unit_value" />
                    <small class="p-error" v-if="validationErrors.unit_value">{{
                        validationErrors.unit_value
                    }}</small>
                </div>
                <div class="p-field">
                    <label for="unitName">Prescription*</label>
                    <Dropdown
                        id="prescription"
                        v-model="product.prescription"
                        :options="yesNoOptions"
                        placeholder="Prescription"
                        :filter="true"
                        optionLabel="option_name"
                        optionValue="id"
                    />
                    <small
                        class="p-error"
                        v-if="validationErrors.prescription"
                        >{{ validationErrors.prescription }}</small
                    >
                </div>
                <div class="p-field">
                    <label for="unitName">Insurance*</label>
                    <Dropdown
                        id="insurance"
                        v-model="product.insurance"
                        :options="yesNoOptions"
                        placeholder="Insurance"
                        :filter="true"
                        optionLabel="option_name"
                        optionValue="id"
                    />
                    <small class="p-error" v-if="validationErrors.insurance">{{
                        validationErrors.insurance
                    }}</small>
                </div>
                <div class="p-field">
                    <label for="expirable">Expirable*</label>
                    <Dropdown
                        id="expirable"
                        v-model="product.expirable"
                        :options="yesNoOptions"
                        placeholder="Expirable"
                        :filter="true"
                        optionLabel="option_name"
                        optionValue="id"
                    />
                    <small class="p-error" v-if="validationErrors.expirable">{{
                        validationErrors.expirable
                    }}</small>
                </div>
            </div>

            <div class="p-col">
                <div class="p-field">
                    <label for="type">Product Type*</label>
                    <Dropdown
                        id="type"
                        v-model="product.type_id"
                        :options="type"
                        placeholder="Product Type"
                        :filter="true"
                        optionLabel="option_name"
                        optionValue="id"
                    />
                    <small class="p-error" v-if="validationErrors.type_id">{{
                        validationErrors.type_id
                    }}</small>
                </div>
                <div class="p-field">
                    <label for="brandName">Brand Name*</label>
                    <Dropdown
                        id="brandName"
                        v-model="product.brand_id"
                        :options="brand"
                        placeholder="Brand Name"
                        :filter="true"
                        optionLabel="option_name"
                        optionValue="id"
                    />
                    <small class="p-error" v-if="validationErrors.brand_id">{{
                        validationErrors.brand_id
                    }}</small>
                </div>
                <div class="p-field">
                    <label for="brandSector">Brand Sector*</label>
                    <Dropdown
                        id="brandSector"
                        v-model="product.brand_sector_id"
                        :options="brandSector"
                        placeholder="Brand Sector"
                        :filter="true"
                        optionLabel="option_name"
                        optionValue="id"
                    />
                    <small
                        class="p-error"
                        v-if="validationErrors.brand_sector_id"
                        >{{ validationErrors.brand_sector_id }}</small
                    >
                </div>
                <div class="p-field">
                    <label for="category">Category*</label>
                    <Dropdown
                        id="category"
                        v-model="product.category_id"
                        :options="category"
                        placeholder="Category"
                        :filter="true"
                        optionLabel="option_name"
                        optionValue="id"
                    />
                    <small
                        class="p-error"
                        v-if="validationErrors.category_id"
                        >{{ validationErrors.category_id }}</small
                    >
                </div>

                <div class="p-field">
                    <label for="sideEffects">Side Effects</label>
                    <InputText
                        id="sideEffects"
                        v-model="product.side_effects"
                    />
                </div>

                <div class="p-field">
                    <label for="description">Description</label>
                    <InputText id="description" v-model="product.description" />
                </div>
            </div>
        </div>

        <template #footer>
            <Button
                type="submit"
                label="Save"
                icon="pi pi-check"
                class="p-button-primary"
                @click.prevent="validateAndSave"
            />
            <Button
                type="button"
                label="Close"
                class="p-button-danger"
                @click.prevent="closeDialog"
            />
        </template>
    </Dialog>
</template>

<script>
import ProductService from "../service/ProductService.js";

export default {
    props: {
        productDialog: Boolean, // Dialog visibility state
        dialogTitle: String, // Title of the dialog
        lastReference: String, // Title of the dialog
    },
    data() {
        return {
            product: {
                product_name: "",
                generic_name: "",
                common_name: "",
                reference: "",
                min_stock: "",
                product_location: "",
                barcode: "",
                unit_id: "",
                unit_value: "",
                prescription: 0,
                insurance: 0,
                expirable: 1,
                brand_sector_id: 2,
                category_id: 3,
                side_effects: "",
                description: "",
                type_id: 4,
                brand_id: 1,
            },
            validationErrors: {},
            yesNoOptions: [
                { id: 0, option_name: "No" },
                { id: 1, option_name: "Yes" },
            ],
            productService: null,
            brand: [],
            brandSector: [],
            type: [],
            category: [],
            unit: [],
        };
    },
    mounted() {
        this.productService = new ProductService();
        this.initializeProductForm(); //
        // Call function when component is loaded
    },

    // methods: {

    //   validateAndSave() {
    //     this.validationErrors = {}; // Reset previous errors

    //     // Required Fields
    //     if (!this.product.product_name) this.validationErrors.product_name = "Product Name is required";
    //     if (!this.product.generic_name) this.validationErrors.generic_name = "Generic Name is required";
    //     if (this.product.insurance === null || this.product.insurance === undefined) {
    //       this.validationErrors.insurance = "Insurance is required";
    //     }
    //     if (this.product.expirable === null || this.product.expirable === undefined) {
    //       this.validationErrors.expirable = "Expirable is required";
    //     }
    //     if (!this.product.type_id) this.validationErrors.type_id = "Product Type is required";
    //     if (!this.product.category_id) this.validationErrors.category_id = "Category is required";

    //     if (!this.product.brand_id) this.validationErrors.brand_id = "Brand Name is required";
    //     if (!this.product.brand_sector_id) this.validationErrors.brand_sector_id = "Brand Sector is required";

    //     if (!this.product.reference) this.validationErrors.reference = "Reference is required";

    //     if (this.product.insurance === null || this.product.insurance === undefined) {
    //       this.validationErrors.insurance = "Insurance is required";
    //     }
    //     if (this.product.expirable === null || this.product.expirable === undefined) {
    //       this.validationErrors.expirable = "Expirable is required";
    //     }
    //     if (this.product.prescription === null || this.product.prescription === undefined) {
    //       this.validationErrors.prescription = "Prescription is required";
    //     }

    //     // Min Stock Validation (Optional, but must be an integer if provided)
    //     if (this.product.min_stock && !/^\d+$/.test(this.product.min_stock)) {
    //       this.validationErrors.min_stock = "Minimum Stock must be an integer";
    //     }

    //     if (this.product.unit_value && !/^\d+(\.\d+)?$/.test(this.product.unit_value)) {
    //       this.validationErrors.unit_value = "Unit Value must be an integer or decimal";
    //     }
    //     // If there are no validation errors, save the product
    //     if (Object.keys(this.validationErrors).length === 0) {
    //       this.saveProduct();
    //     }
    // },

    // saveProduct() {
    //   this.$emit("save-product", this.product); // Emit product data to parent
    //   this.$emit("close-dialog");
    // },

    // closeDialog() {
    //   this.$emit("close-dialog");
    // },

    // initializeProductForm(){
    //   this.productService.getItems().then((res) => {
    //     if (res != null) {
    //       //console.log("products index ",res);
    //       this.brand = res.brand;
    //       this.brandSector = res.brandSector;
    //       this.category =res.category;
    //       this.type = res.productType;
    //       this.unit = res.unit;
    //     }
    //   });
    // }

    // },
    methods: {
        validateAndSave() {
            //console.log("validate and save in the product form");
            this.validationErrors = {}; // Reset previous errors

            // Required Fields
            if (!this.product.product_name)
                this.validationErrors.product_name = "Product Name is required";
            if (!this.product.generic_name)
                this.validationErrors.generic_name = "Generic Name is required";
            if (
                this.product.insurance === null ||
                this.product.insurance === ""
            ) {
                this.validationErrors.insurance = "Insurance is required";
            }
            ////console.log("expirable value is ", this.product.expirable);
            if (
                this.product.expirable === null ||
                this.product.expirable === ""
            ) {
                this.validationErrors.expirable = "Expirable is required";
            }
            if (!this.product.type_id)
                this.validationErrors.type_id = "Product Type is required";
            if (!this.product.category_id)
                this.validationErrors.category_id = "Category is required";

            if (!this.product.brand_id)
                this.validationErrors.brand_id = "Brand Name is required";
            if (!this.product.brand_sector_id)
                this.validationErrors.brand_sector_id =
                    "Brand Sector is required";

            if (!this.product.reference) {
                this.validationErrors.reference = "Reference is required";
            } else if (!this.isAlphanumeric(this.product.reference)) {
                this.validationErrors.reference =
                    "Reference should be letters or digits";
            }

            if (
                this.product.insurance === null ||
                this.product.insurance === undefined
            ) {
                this.validationErrors.insurance = "Insurance is required";
            }
            if (
                this.product.expirable === null ||
                this.product.expirable === undefined
            ) {
                this.validationErrors.expirable = "Expirable is required";
            }
            if (
                this.product.prescription === null ||
                this.product.prescription === ""
            ) {
                this.validationErrors.prescription = "Prescription is required";
            }

            // Min Stock Validation (Optional, but must be an integer if provided)
            if (
                this.product.min_stock &&
                !/^\d+$/.test(this.product.min_stock)
            ) {
                this.validationErrors.min_stock =
                    "Minimum Stock must be an integer";
            }

            if (
                this.product.unit_value &&
                !/^\d+(\.\d+)?$/.test(this.product.unit_value)
            ) {
                this.validationErrors.unit_value =
                    "Unit Value must be an integer or decimal";
            }
            // If there are no validation errors, save the product
            if (Object.keys(this.validationErrors).length === 0) {
                this.saveProduct();
            }
        },

        isAlphanumeric(value) {
            //console.log("is alpha numeric fucntion", ("" || /^[A-Za-z0-9]+$/.test(value)));
            return value === "" || /^[A-Za-z0-9]+$/.test(value);
        },

        saveProduct() {
            //console.log("THE PRODUCT IS ",this.product);
            this.$emit("save-product", this.product);
            this.$emit("close-dialog");
            this.resetForm(); // Clear the form after save
        },

        closeDialog() {
            //console.log("close dialog in form");
            this.$emit("close-dialog");
            this.resetForm(); // Clear the form after close
        },

        resetForm() {
            this.product = {
                product_name: "",
                generic_name: "",
                common_name: "",
                reference: "",
                min_stock: "",
                product_location: "",
                barcode: "",
                unit_id: "",
                unit_value: "",
                prescription: 0,
                insurance: 0,
                expirable: 1,
                brand_sector_id: 2,
                category_id: 3,
                side_effects: "",
                description: "",
                type_id: 4,
                brand_id: 1,
            };

            this.validationErrors = {};
        },

        initializeProductForm() {
            this.productService.getItems().then((res) => {
                if (res != null) {
                    this.brand = res.brand;
                    this.brandSector = res.brandSector;
                    this.category = res.category;
                    this.type = res.productType;
                    this.unit = res.unit;
                }
            });
        },
    },
};
</script>
<style scoped>
.small-span-ref{
    font-size: small;
}
</style>
